{
  "auth": {
    "logoAlt": "Smart Word Labs",
    "checkEmail": {
      "title": "Vérifiez vos e-mails",
      "confirmationBody": "Nous avons envoyé un lien de confirmation à <strong>{{email}}</strong>. Confirmez-le pour activer votre compte, puis connectez-vous.",
      "magicLinkBody": "Nous avons envoyé un lien de connexion à usage unique à <strong>{{email}}</strong>. Ouvrez-le sur cet appareil pour vous connecter.",
      "backToSignIn": "Retour à la connexion Parent"
    },
    "heading": {
      "magicMode": "Connexion par lien magique",
      "signup": "Créez votre compte parent",
      "signin": "Connexion Parent"
    },
    "subheading": {
      "magicMode": "Entrez votre e-mail et nous vous enverrons un lien de connexion à usage unique.",
      "signup": "Gérez les cours de vos enfants, la facturation et les progrès en un seul endroit.",
      "signin": "Connectez-vous à votre portail parent."
    },
    "social": {
      "google": "Continuer avec Google",
      "apple": "Continuer avec Apple"
    },
    "or": "ou",
    "fields": {
      "email": "E-mail",
      "password": "Mot de passe",
      "fullName": "Nom complet",
      "country": "Pays",
      "phone": "Téléphone"
    },
    "buttons": {
      "pleaseWait": "Veuillez patienter…",
      "sendMagicLink": "Envoyer le lien magique",
      "createAccount": "Créer un compte",
      "signIn": "Se connecter"
    },
    "toggle": {
      "useMagicLink": "M'envoyer un lien magique plutôt",
      "usePassword": "Utiliser l'e-mail et le mot de passe plutôt"
    },
    "footer": {
      "haveAccount": "Vous avez déjà un compte ?",
      "signIn": "Se connecter",
      "newHere": "Nouveau chez Smart Word Labs ?",
      "bookAssessment": "Réserver une évaluation gratuite"
    },
    "errors": {
      "couldNotSignIn": "Impossible de se connecter",
      "enterEmailFirst": "Entrez d'abord votre e-mail",
      "somethingWentWrong": "Une erreur s'est produite"
    },
    "toasts": {
      "magicLinkSent": "Lien de connexion envoyé — vérifiez vos e-mails"
    }
  },
  "reviews": {
    "title": "Avis des parents",
    "description": "Retours honnêtes des familles apprenant avec Smart Word Labs. Partagez votre propre expérience ci-dessous — les avis apparaissent ici une fois que nous les avons vérifiés.",
    "starsAriaLabel": "{{rating}} étoiles sur 5",
    "starPickerAriaLabel": "Évaluation par étoiles",
    "starAriaLabel": "{{count}} étoile",
    "starAriaLabel_plural": "{{count}} étoiles",
    "whatParentsSay": "Ce que les parents disent",
    "empty": "Aucun avis publié pour le moment — le vôtre pourrait être le premier.",
    "form": {
      "title": "Écrire un avis",
      "yourRating": "Votre évaluation",
      "yourName": "Votre nom",
      "email": "E-mail (facultatif, non publié)",
      "childAge": "Âge de l'enfant (facultatif)",
      "location": "Ville / pays (facultatif)",
      "yourReview": "Votre avis",
      "bodyPlaceholder": "Qu'est-ce qui a changé pour votre enfant ? Qu'appréciez-vous dans les cours ?",
      "website": "Site web",
      "submit": "Envoyer l'avis"
    },
    "sent": {
      "title": "Avis reçu",
      "body": "Merci de partager votre expérience. Nous publions les avis après une vérification rapide.",
      "writeAnother": "Écrire un autre avis"
    },
    "errors": {
      "chooseRating": "Veuillez choisir une évaluation par étoiles.",
      "tooFast": "C'était rapide ! Veuillez prendre un moment et réessayer.",
      "bodyTooShort": "Veuillez écrire au moins quelques phrases.",
      "checkForm": "Veuillez vérifier le formulaire",
      "saveFailed": "Nous n'avons pas pu enregistrer votre avis. Veuillez réessayer."
    },
    "toasts": {
      "submitted": "Merci — votre avis a été soumis pour vérification."
    }
  }
}
